/* ============================================================
   Product Showcase — section-product-showcase.js
   Scroll-in animation + stagger. No deps.
   ============================================================ */
(function () {
  'use strict';

  const SELECTOR = '[data-product-showcase]';
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    const animation = root.dataset.animation;
    if (!animation || animation === 'none' || prefersReduced) {
      root.classList.add('is-in-view');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-in-view');
      return;
    }
    const io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(root);
    root.__psObserver = io;
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.__psInitialized) {
        el.__psInitialized = true;
        setup(el);
      }
    });
  }

  function destroy(el) {
    if (el && el.__psObserver) {
      el.__psObserver.disconnect();
      el.__psObserver = null;
      el.__psInitialized = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify Theme Editor events */
  document.addEventListener('shopify:section:load',   function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target.querySelector(SELECTOR)); });
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target.querySelector(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest(SELECTOR);
    if (el) el.classList.add('is-in-view');
  });
})();
